/* Change this file to get your personal Porfolio */

const greeting = {
	title: "Hi all 👋 I'm Abhishek",
	nickname: "AbhiSaphire",
	subTitle:
		"A tireless seeker of knowledge & humour and also coincidentally a Computer Engineer. This is my little space on Internet where you can always find me and my work.",
  	resumeLink:
		"https://drive.google.com/file/d/1s3MIKZ1aLKcrom2M7nQd-cOyoCCnmZ2J/view?usp=sharing"
};

const socialMediaLinks = {
	/* Your Social Media Link */
	github: "https://github.com/abhisaphire",
	linkedin: "https://www.linkedin.com/in/abhisaphire",
	gmail: "iabhikmr2000@gmail.com",
	twitter: "https://twitter.com/abhisaphire",
	instagram: "https://www.instagram.com/abhisaphire"
};

const skills = {
  data: [
    {
      title: "ML & Data Science",
      imagePath: "data_science.svg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ A passionate individual who always thrive to work on end to end products which develop sustainable and scalable social and technical systems to create impact",
        "⚡ Experience of collaborating with mlpack organization"
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent"
          }
        },
        {
          skillName: "Kaggle",
          fontAwesomeClassname: "simple-icons:kaggle",
          style: {
            backgroundColor: "transparents",
            color: "#25d9b5"
          }
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent"
          }
        },
        {
          skillName: "Jupyter Notebook",
          fontAwesomeClassname: "logos-jupyter",
          style: {
            backgroundColor: "transparent"
          }
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB"
          }
        }
      ]
    },
    {
      title: "Full Stack Development",
      imagePath: "fullstack.svg",
      skills: [
        "⚡ Building resposive website front end using Bootstrap, JQuery and React",
        "⚡ Developing mobile and console 2D games using godot",
        "⚡ Creating powerful application backend in Flask, Django & Streamlit",
        "⚡ Experience working on multiple cloud platforms"
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26"
          }
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6"
          }
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699"
          }
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E"
          }
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: {
            color: "#1572B6"
          }
        },
        {
          skillName: "Django",
          fontAwesomeClassname: "simple-icons:django",
          style: {
            color: "#0d2915"
          }
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791"
          }
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837"
          }
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "simple-icons:php",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB"
          }
        },
      ]
    },
    // {
    //   title: "UI/UX Design",
    //   imagePath: "ui_ux_design.svg",
    //   skills: [
    //     "⚡ Designing highly attractive user interface for mobile and web applications",
    //     "⚡ Customizing logo designs and building logos from scratch",
    //     "⚡ Creating the flow of application functionalities to optimize user experience"
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "Figma",
    //       fontAwesomeClassname: "simple-icons:figma",
    //       style: {
    //         color: "#F24E1E"
    //       }
    //     },
    //     {
    //       skillName: "Adobe Illustrator",
    //       fontAwesomeClassname: "simple-icons:adobeillustrator",
    //       style: {
    //         color: "#FF7C00"
    //       }
    //     },
    //     {
    //       skillName: "Inkscape",
    //       fontAwesomeClassname: "simple-icons:inkscape",
    //       style: {
    //         color: "#000000"
    //       }
    //     }
    //   ]
    // },
    {
      title: "In My Free Time ? 🤩",
      imagePath: "relax.svg",
      skills: [
        "⚡ I like playing multiplayer FPS games. Why? Due to the intricate strategies, but that's not all. It also promotes teamwork, boosted my self reliance and improved my social interaction capacity.",
        "⚡ I'm an avid reader. I like reading thriller genre novels and books. I’ve completed almost all the best seller thriller novels. Why thrillers? because they help me to take an escape from time to time.",
        "⚡ I'm an Ubuntu enthusiast, and I like tweaking my terminal with plugins.",
        "⚡ I'm also quite passionate about stand-up comedy. I've seen many Indian comics perform - such as Zakir Khan, Kenny Sebastian, AIB group, Biswa Kalyan Rath, Tanmay Bhatt, etc. This might be the arena where my second cup of tea(job) lies.",
        "⚡ Also Cooking and obviously eating alot."
      ],
      softwareSkills: [
        {
          skillName: "Reading",
          fontAwesomeClassname: "simple-icons:audible",
          style: {
            color: "#1572B6"
          }
        },
        {
          skillName: "Gaming",
          fontAwesomeClassname: "simple-icons:grav",
          style: {
            color: "#000000"
          }
        }
      ]
    }
  ]
};

const competitiveSites = {
  competitiveSites: [
    // {
    //   siteName: "Leetcode",
    //   iconifyClassname: "simple-icons:leetcode",
    //   style: {
    //     color: "#ffdd1f",
    //     backgroundColor: "transparent"
    //   },
    //   profileLink: "https://www.leetcode.com/abhisaphire"
    // },
    // {
    //   siteName: "GeeksforGeeks",
    //   iconifyClassname: "simple-icons:goodreads",
    //   style:{
    //     color: "#65ff24",
    //   },
    //   profileLink: "https://auth.geeksforgeeks.org/user/abhisaphire/practice/"
    // },
    // {
    //   siteName: "Kaggle",
    //   iconifyClassname: "simple-icons:kaggle",
    //   style: {
    //     color: "#20BEFF"
    //   },
    //   profileLink: "https://www.kaggle.com/abhisaphire"
    // }
  ]
}

const degrees = {
  degrees : [
    {
      title: "G.H. Raisoni College of Engineering & Management Pune",
      subtitle: "B.Tech. in Computer Engineering",
      logo_path: "ghrcem_logo.png",
      alt_name: "GHRCEM Pune",
      duration: "2017 - Present(2021)",
      descriptions: [
        "⚡ I have applied for software engineering academic courses like DS, Algorithms, DBMS, OS, CA, ML & AI etc.",
        "⚡ Apart from this, I have done online courses on basics to advance Machine learning, Deep Learning and Data Science.",
        "⚡ Built strong foundation in maths, logic, programming skills, analytical aptitude, machine learning and also web application development."
      ],
      website_link: "https://ghrcem.raisoni.net"
    }
  ]
}

const certifications = {
	certifications: [
    {
      title: "Software Engineering Virtual Experience",
      subtitle: "- JP Morgan Chase & Co.",
      logo_path: "JPMC.jpg",
      certificate_link:
        "https://drive.google.com/file/d/1mRpJjiZ9dcw9w3aQiBgniocYm57KsdOg/view?usp=sharing",
      alt_name: "JP Morgan Chase & Co.",
      color_code: "#000000"
    },
		{
			title: "Machine Learning",
			subtitle: "- Andrew Ng",
			logo_path: "stanford_logo.png",
			certificate_link:
				"https://coursera.org/share/1d8cd1597ed41e5136d45576039f1ce1",
			alt_name: "Stanford University",
			color_code: "#8C151599"
		},
    {
      title: "Algorithmic Toolbox",
      subtitle: "- Daniel Kane, Alexander S. Kulikov",
      logo_path: "UCSD.svg",
      certificate_link:
        "https://coursera.org/share/bc7663a513cd2cfe9f53b3fa7ce2de6e",
      alt_name: "Univeristy of California San Diego",
      color_code: "#bfffff"
    },
    {
      title: "Natural Language Processing",
      subtitle: "- Codecademy",
      logo_path: "codecademy.svg",
      certificate_link:
        "https://drive.google.com/file/d/1uwG1sz79fDKANVgjzZKEqydVLQAJUC6a/view?usp=sharing",
        alt_name: "Codecademy",
        color_code: "#9e9898"
    },
    {
      title: "Deep Learning A-Z",
      subtitle: "- Kirill Eremenko",
      logo_path: "udemy.svg",
      certificate_link:
        "https://www.udemy.com/certificate/UC-82106794-9d80-47b2-80a1-9074ef93d37a/",
      alt_name: "Udemy",
      color_code: "#00000099"
    },
		{
			title: "Machine Learning A-Z",
			subtitle: "- Kirill Eremenko",
			logo_path: "udemy.svg",
			certificate_link:
				"https://www.udemy.com/certificate/UC-e0ab314e-8b5e-400a-8cb2-9341f9edc73a",
			alt_name: "Udemy",
			color_code: "#00000099"
		},
    {
      title: "Build a Data Science Web App with Streamlit and Python",
      subtitle: "- Snehan Kekre",
      logo_path: "coursera.svg",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/records/LEV5BDUC3KN6",
        alt_name: "rhyme",
        color_code: "#1e4866"
    }
	]
};

const openSource = {
  githubConvertedToken: "ZGEwMzQ4ZDlhZDY5YzBiNTFhOGY2MGUxZmE0NWY0NDZlZmQ3Y2Q4YQ==",
  githubUserName: "AbhiSaphire"
};

const bigProjects = {
  /* Some Big Projects You have worked with your company */
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELP TO CREATE THEIR TECH",
  projects: [
  ]
};

const achievementSection = {
  /* Your Achievement Section Include Your Certification Talks and More */

  // title: "Achievements And Certifications 🏆 ",
  // subtitle:
  //   "Achievements, Certifications Award Letters and Some Cool Stuff that i have done !",

  // achivementsCards: [
    // {
    //   title: "Google Code-In Finalist",
    //   description:
    //     "First Pakistani to be selected as Google Google-in Finalist from 4000 students from 77 diffrent countries",
    //   image:
    //     "https://1.bp.blogspot.com/-Ig-v1tDXZt4/XDODmZvWp1I/AAAAAAAAB0A/KtbFdBPFVQw2O15FekkIR0Yg8MUp--rngCLcBGAs/s1600/GCI%2B-%2BVertical%2B-%2BGray%2BText%2B-%2BWhite%2BBG.png",
    //   footerLink: [
    //     {
    //       name: "Certification",
    //       url:
    //         "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
    //     },
    //     {
    //       name: "Award Letter",
    //       url:
    //         "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
    //     },
    //     {
    //       name: "Google Code-in Blog",
    //       url:
    //         "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
    //     }
    //   ]
    // }
  // ]
};

const blogSection = {
  /* Blogs Section */

  // title: "Blogs",
  // subtitle:
  //   "With love for individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
  // link: "https://abhisaphire.github.io/#work",
  // avatar_image_path: "blogs_image.svg"

  
};

// Talks Sections

const talkSection = {
  // title: "TALKS",
  // subtitle: "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅",

  // talks: [
  //   {
  //     title: "Build Actions For Google Assistant",
  //     subtitle: "Codelab at GDG DevFest Karachi 2019",
  //     slides_url: "https://bit.ly/saadpasta-slides",
  //     event_url: "https://www.facebook.com/events/2339906106275053/",
  //     image:
  //       "https://scontent.fkhi6-1.fna.fbcdn.net/v/t1.0-9/76714032_1730516240415559_1293494289556307968_o.jpg?_nc_cat=103&_nc_ohc=s5f81rdZd6wAQmqUa52YQBA21MjVOy7e-HN9jI7MspRDC-v5ahEouyInQ&_nc_ht=scontent.fkhi6-1.fna&oh=c29141a9a0de7ff2011a8191f5475a78&oe=5E83127C"
  //   }
  // ]
};

// Podcast Section
const podcastSection = {};

export {
	// theme,
	 greeting,
	 socialMediaLinks,
	 skills,
	 competitiveSites,
	 degrees,
	 certifications,
	// openSource,
	 bigProjects,
	 achievementSection,
	 blogSection,
	 talkSection,
	 podcastSection,
	// contactInfo
};
